import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource} from '@api'
import {useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import * as css from './ExportChangeLogButton.css'

/// region Store

export class ExportChangeLogButtonStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }
}

export const ExportChangeLogButtonStoreContext = React.createContext<ExportChangeLogButtonStore>(null)
export const useExportChangeLogButtonStore = () => React.useContext(ExportChangeLogButtonStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const ExportChangeLogButton = observer<MyProps>(function ExportChangeLogButton({className, ...props}) {
  const obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new ExportChangeLogButtonStore(stores, obsProps)),
    {} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <ExportChangeLogButtonStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}>

      </div>
    </ExportChangeLogButtonStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/changelog/toolbar/ExportChangeLogButton.tsx